import { Col, Input } from 'antd'
import CIMSFormItemList from 'components/CIMSFormItemList'
import CIMSFormItem from 'components/CIMSFormItem'

const TechnicalDirectionsFormItems: React.VFC = () => (
  <CIMSFormItemList
    name="approvalGroups"
    label="Approval Group"
    help="A list of Approval Groups to be added to the workflow"
    validate={(groups) =>
      groups?.length > 0
        ? true
        : 'Technical Directions must have at least one Approval Group'
    }
    buttons={[
      {
        type: 'simple',
        icon: 'add',
        add: () => ({
          label: null,
          tooltip: null,
        }),
      },
    ]}
  >
    {(number) => (
      <>
        <Col style={{ maxWidth: '280px' }} flex={2}>
          <CIMSFormItem
            label="Label"
            name={[number, 'label']}
            requiredMessage="Please enter a label"
          >
            <Input />
          </CIMSFormItem>
        </Col>
        <Col style={{ maxWidth: '280px' }} flex={2}>
          <CIMSFormItem label="Tooltip" name={[number, 'tooltip']}>
            <Input />
          </CIMSFormItem>
        </Col>
      </>
    )}
  </CIMSFormItemList>
)

export default TechnicalDirectionsFormItems
